import {
    MANAGEMENT_REPORT_SUCCESS,
    MANAGEMENT_REPORT_BEGIN,
    MANAGEMENT_REPORT_FAILURE,
    CLEAR_MANAGEMENT_REPORT,
    
    MANAGEMENT_REPORT_FILTERS_SUCCESS,
    MANAGEMENT_REPORT_FILTERS_BEGIN,
    MANAGEMENT_REPORT_FILTERS_FAILURE,
    CLEAR_MANAGEMENT_REPORT_FILTERS
} from 'app/actions/ManagementReportActions';

const initialState = {
    filters: [],
    data: {},
    isLoading: false,
};

export default function ManagementReportReducer(state = initialState, action) {
    switch (action.type) {
        case MANAGEMENT_REPORT_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case MANAGEMENT_REPORT_SUCCESS:
            let data={...state.data, pdf: action.payload.data}
            return {
                ...state,
                data,
                isLoading: false,
            };
        case MANAGEMENT_REPORT_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_MANAGEMENT_REPORT:
            return {
                ...state,
                data: [],
                isLoading: false,
            }
        case MANAGEMENT_REPORT_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case MANAGEMENT_REPORT_FILTERS_SUCCESS:
            let filters = [...new Set(state.filters.concat(action.payload.data))];

            return {
                ...state,
                filters,
                isLoading: false,
            };
        case MANAGEMENT_REPORT_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_MANAGEMENT_REPORT_FILTERS:
            return {
                ...state,
                filters: [],
                isLoading: false,
            }
        default:
            return state;
    }
};

export const getManagementReportFilters = state => {
    return state.filters;
}
export const getIsLoadingManagementReportFilters = state => {
    return state.isLoading;
}

export const getManagementReport = state => {
    return state.data;
}
export const getIsLoadingManagementReport = state => {
    return state.isLoading;
}